import { ReplenishmentTemplateCreatePage } from '@/features/replenishment-template/pages/ReplenishmentTemplateCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/replenishment-template/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["replenishment_template.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ReplenishmentTemplateCreatePage,
});
